export default "__VITE_ASSET__kK3ztHwd__"